import { BottomSheet } from './BottomSheet';
import { Zap, Radio, Box, Circle, Activity } from 'lucide-react';

import imageSrcPP from '../../images/ps.svg';
import imageSrcTP from '../../images/tp.svg';
import imageSrcRP from '../../images/rp.svg';
import imageSrcRecloser from '../../images/rk.svg';

const OBJECT_TYPES = [
   { key: 'PS', label: 'ПС', icon: <img src={imageSrcPP} width={20} height={20} alt="ПС" />, color: '#ff0000' },
  { key: 'RP', label: 'РП', icon: <img src={imageSrcRP} width={20} height={20} alt="РП" />, color: '#3b82f6' },
  { key: 'TP', label: 'ТП', icon: <img src={imageSrcTP} width={20} height={20} alt="ТП" />, color: '#ffc400' },
  { key: 'Recloser', label: 'Реклоузер', icon: <img src={imageSrcRecloser} width={20} height={20} alt="Реклоузер" />, color: '#8b5cf6' },
  { key: 'circle', label: 'Опора', icon: <Circle size={20} />, color: '#ff0000' },
];

export function AddObjectSheet({ onClose, onSelect }) {
  return (
    <BottomSheet title="Добавить объект" onClose={onClose} open={true} modal={true}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {OBJECT_TYPES.map((type) => (
          <button
            key={type.key}
            onClick={() => { onSelect(type.key); onClose(); }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '14px',
              padding: '14px 16px',
              borderRadius: '12px',
              border: 'none',
              background: '#f5f5f5',
              cursor: 'pointer',
              fontSize: '15px',
              fontWeight: 500,
              color: '#1a1a1a',
              width: '100%',
              textAlign: 'left'
            }}
          >
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '10px',
              background: type.color + '20',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: type.color,
              flexShrink: 0
            }}>
              {type.icon}
            </div>
            {type.label}
          </button>
        ))}
      </div>
    </BottomSheet>
  );
}